<template>
  <GetStartedInstructions
    :localStorageKey="localStorageKey"
    primaryLink="https://support.jumpcloud.com/support/s/article/getting-started-applications-saml-sso2"
    primaryLinkText="learn more"
    secondaryLinkText="watch a video"
    :startCollapsed="collapsed"
    title="Get Started with SSO Applications"
    :videoModalUrls="videoModalUrls"
  >
    <GetStartedStep
      :icon="icons.IconStep1"
      :step="1"
      text="Select an application to connect with JumpCloud through SAML 2.0-based SSO."
    />
    <GetStartedStep
      :class="$style.step2"
      :icon="icons.IconStep2"
      :step="2"
    >
      Configure Your Application
      <ul>
        <li>
          Each application has its own set of instructions and requirements to connect to JumpCloud.
        </li>
        <li>
          Be sure to have an application’s SAML / SSO documentation available while you connect
          it with JumpCloud.
        </li>
      </ul>
    </GetStartedStep>
    <GetStartedStep
      :icon="icons.IconStep3"
      :step="3"
      text="Grant User access to the application through User Groups."
    />
  </GetStartedInstructions>
</template>

<script>
import { LocalStorageConsts } from 'client/util/Constants';
import GetStartedInstructions from 'client/components/GetStartedInstructions/GetStartedInstructions.vue';
import GetStartedStep from 'client/components/GetStartedInstructions/GetStartedStep.vue';
import IconStep1 from 'public/img/icons/icon-step-1-configure-radius.svg?inline';
import IconStep2 from 'public/img/icons/icon-step-2-directories.svg?inline';
import IconStep3 from 'public/img/icons/icon-step-3-grant-access-radius.svg?inline';

const { applicationInstructionsDismissed } = LocalStorageConsts;

export default {
  name: 'ApplicationInstructions',

  components: {
    GetStartedInstructions,
    GetStartedStep,
  },

  data: () => ({
    collapsed: false,
    localStorageKey: applicationInstructionsDismissed,
    icons: {
      IconStep1,
      IconStep2,
      IconStep3,
    },
    videoModalUrls: {
      videoIframeUrl: 'https://jumpcloud-1.wistia.com/embed/iframe/x8aajrzloo',
      videoUrl: 'https://jumpcloud-1.wistia.com/medias/x8aajrzloo',
    },
  }),
};
</script>

<style module>

.step2 ul {
  list-style: none;
  margin-top: 1rem;
  padding-left: 0;
}

.step2 li {
  margin-bottom: 1rem;
}

</style>
